import EnquiryForm from './EnquiryForm';

export const Empty = {
  component: EnquiryForm,
  props: {
    formId: 'EnquiryFormExample',
    listingTitle: 'Sauna with a view',
    authorDisplayName: 'Janne',
    onSubmit(values) {
      
    },
  },
  group: 'forms',
};
